import React from 'react';

function Header() {
    return (<header>Level 200 Sample Solution - React</header>);
}

export default Header;